import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const PlusIcon: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => (
    <svg
        className={`${className} ${styles.plusIcon}`}
        data-testid={testId}
        fill='none'
        height='12'
        viewBox='0 0 12 12'
        width='12'
        xmlns='http://www.w3.org/2000/svg'>
        <path d='M5 0.75H7V5H11.25V7H7V11.25H5V7H0.75V5H5V0.75Z' fill='currentColor' />
    </svg>
);

export default PlusIcon;
